import React from 'react';
import { useTranslation } from 'react-i18next';
import BottomSheet from '../components/BottomSheet';
import VerbatimQuote from '../components/VerbatimQuote';
import RecoBadge from '../components/RecoBadge';
import { categoryEmoji, categoryLabel, typeBadge } from '../utils/insights';

export default function CategoryDetailModal({ group, open, onClose }) {
  const { t } = useTranslation('tabs');
  if (!group) {
    return <BottomSheet open={open} onClose={onClose} title="" height="auto" />;
  }
  const { category, insights, score, dominantType } = group;
  const badge = typeBadge(dominantType, t);

  return (
    <BottomSheet open={open} onClose={onClose} title={t('insights.detail_modal_title')} height="full">
      <div style={styles.head}>
        <div style={styles.headTop}>
          <span style={styles.emoji} aria-hidden>{categoryEmoji(category)}</span>
          <span style={styles.label}>{categoryLabel(category, t)}</span>
          <span style={styles.score}>{score}/100</span>
        </div>
        <RecoBadge variant={badge.variant} label={badge.label} />
      </div>

      <div style={styles.list}>
        {insights.map((insight, idx) => (
          <div key={idx} style={styles.insightBlock}>
            {insight.titre && <h3 style={styles.insightTitre}>{insight.titre}</h3>}
            {insight.constat && <p style={styles.constat}>{insight.constat}</p>}
            {insight.action && (
              <p style={styles.action}><strong>Action :</strong> {insight.action}</p>
            )}
            {Array.isArray(insight.verbatims) && insight.verbatims.length > 0 && (
              <div style={styles.verbatims}>
                {insight.verbatims.map((v, vi) => (
                  <VerbatimQuote key={vi} text={v} />
                ))}
              </div>
            )}
            {insight.date_range && (
              <p style={styles.dateRange}>Période observée : {insight.date_range}</p>
            )}
          </div>
        ))}
      </div>
    </BottomSheet>
  );
}

const styles = {
  head: {
    display: 'flex',
    flexDirection: 'column',
    gap: 10,
    marginBottom: 16,
    paddingBottom: 12,
    borderBottom: '1px solid #EDEAE3',
  },
  headTop: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
  },
  emoji: {
    fontSize: 24,
    lineHeight: 1,
  },
  label: {
    fontSize: 18,
    fontWeight: 700,
    color: '#1A1A1A',
    flex: 1,
  },
  score: {
    fontSize: 14,
    fontWeight: 700,
    color: '#1A1A1A',
  },
  list: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
  },
  insightBlock: {
    background: '#FFFFFF',
    border: '1px solid #EDEAE3',
    borderRadius: 12,
    padding: 14,
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
  },
  insightTitre: {
    margin: 0,
    fontSize: 15,
    fontWeight: 700,
    color: '#1A1A1A',
  },
  constat: {
    margin: 0,
    fontSize: 13,
    color: '#1A1A1A',
    lineHeight: 1.5,
  },
  action: {
    margin: 0,
    fontSize: 13,
    color: '#1A1A1A',
    lineHeight: 1.5,
  },
  verbatims: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    marginTop: 4,
  },
  dateRange: {
    margin: 0,
    fontSize: 12,
    color: '#6B6B6B',
    fontStyle: 'italic',
  },
};
